const Link = {
  variants: {
    sidebar: {
      color: 'teal.200',
    },
  },
}

export default Link
